const CustomSelect = ({
  errors,
  name,
  placeholder,
  register,
  options,
  floatingLabel,
  className = "",
  ...props
}) => {
  const hasError = !!errors?.[name];

  return (
    <div className={`relative ${className}`}>
      <select
        id={name}
        className={`peer w-full appearance-none rounded-[4px] border bg-white text-[15px] font-normal outline-none transition-all
          ${floatingLabel ? "h-[56px] pt-6 pb-1 px-4" : "py-2 px-4"}
          ${hasError ? "border-red-500 focus:border-red-500" : "border-gray-200 hover:border-[#8F8F8F] focus:!border-darkslateblue"}
          [&>option]:text-gray-700 
          [&>option:hover]:bg-gray-50 
          [&>option:checked]:bg-blue-50 
          [&>option:not(:checked)]:bg-white
          [&>option]:cursor-pointer 
          [&>option]:px-4 [&>option]:py-3
        `}
        {...props}
        {...register}
      >
        {/* If not floatingLabel, use placeholder as first <option> */}
        {!floatingLabel && placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      {/* Floating label */}
      {floatingLabel && placeholder && (
        <label
          htmlFor={name}
          className={`pointer-events-none absolute left-4 top-2 text-[14px] transition-all
            peer-placeholder-shown:top-4 peer-placeholder-shown:text-base
            peer-focus:top-2 peer-focus:text-[14px]
            ${hasError ? "text-red-500" : "text-smokey-grey"}
          `}
        >
          {placeholder}
        </label>
      )}

      {/* Arrow icon */}
      <div className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2">
        <svg
          className="h-5 w-5 fill-gray-400 transition peer-focus:fill-darkslateblue"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>

      {hasError && (
        <p className="mt-1.5 text-xs font-medium text-red-500">
          {errors[name]?.message}
        </p>
      )}
    </div>
  );
};

export default CustomSelect;
